import React from "react";
import { LivePal, GearPal, GearItem } from "../../types/Pal";
import LivePalDetails from "./LivePalDetails";
import GearPalDetails from "./GearPalDetails";
import ContactButton from "./ContactButton";

interface PalPopupContentProps {
  pal: LivePal | GearPal;
  onSelectItem: (item: GearItem) => void;
  onAddItem?: () => void;
  onEditItem?: (item: GearItem) => void;
  onDeleteItem?: (id: number) => void;
}

const PalPopupContent: React.FC<PalPopupContentProps> = ({
  pal,
  onSelectItem,
  onAddItem,
  onEditItem,
  onDeleteItem,
}) => {
  return (
    <div className="space-y-8 animate-scale-in">
      {pal.type === "LivePal" ? (
        <LivePalDetails
          pal={
            {
              ...pal,
              contacts: [
                ...pal.contacts,
                { ...(pal.email ? { type: "email", value: pal.email } : {}) },
                {
                  ...(pal.website
                    ? { type: "website", value: pal.website }
                    : {}),
                },
              ].filter((contact) => contact.value),
            } as LivePal
          }
        />
      ) : (
        <GearPalDetails
          pal={pal as GearPal}
          onSelectItem={onSelectItem}
          onAddItem={onAddItem}
          onEditItem={onEditItem}
          onDeleteItem={onDeleteItem}
        />
      )}
    </div>
  );
};

export default PalPopupContent;
